import videojs from 'video.js';

import { Event } from '@src/types/event';
import { removeAllChildNodes } from '@src/utils/dom';

export const PosterImage = videojs.getComponent('PosterImage');

class CustomPosterImage extends PosterImage {
  createEl() {
    const el = super.createEl();

    removeAllChildNodes(el); // introduced in video.js v8, a lazy load <img /> is appended; remove it first

    el.classList.add('vjs-custom-poster');

    const underlay = videojs.dom.createEl('div', {
      className: 'vjs-poster__underlay',
    });

    const mainImage = videojs.dom.createEl('div', {
      className: 'vjs-poster__main',
    });

    el.appendChild(underlay);
    el.appendChild(mainImage);

    return el;
  }

  setSrc(url: string) {
    let backgroundImage = '';

    const _el = this.el();

    // Any falsy value should stay as an empty string, otherwise
    // this will throw an extra error
    if (url) {
      _el.classList.add('vjs-poster--has-poster');
      backgroundImage = `url("${url}")`;
    }

    const underlay: HTMLDivElement | null = this.el().querySelector(
      '.vjs-poster__underlay'
    );

    const mainImage: HTMLDivElement | null =
      this.el().querySelector('.vjs-poster__main');

    if (mainImage) {
      mainImage.style.backgroundImage = backgroundImage;
    }

    if (underlay) {
      underlay.style.backgroundImage = backgroundImage;
    }
  }

  handleClick(evt: videojs.EventTarget.Event) {
    this.player_.trigger(Event.X_CLICK_POSTER);
    super.handleClick(evt);
  }
}

videojs.registerComponent('CustomPosterImage', CustomPosterImage);

export default CustomPosterImage;
